<template>
  <div class="dashboard background">
    <dashboard-page pcontent="1" page="TICKETS">
      <card w='60%' minWidth='1050px' v-if='true'>
        <!-- list of tickets -->
        <div class="fCol jStart aStart fullWidth"
          v-if="activeForm === 'list'">
          <!-- card header -->
          <div class='fRow fullWidth jStart aCenter' style="margin-bottom: 32px">
            <div class='growFull fCol jStart aStart'>
              <h3 class='growFull text-right'>تیکت‌های کاربران</h3>
              <p class='note'>پیام های ارسالی توسط کاربران را مدیریت کنید.
              </p>
            </div>
            <btn
              label='به‌روز رسانی'
              :fab="true"
              :mini="true"
              v-if="true"
              ic='sync'/>
          </div>
          <!-- filter and sort -->
          <div class="fRow jBetween aStart fullWidth wrap">
            <div class="fCol jStart aStart formTop">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round">filter_list</i>
                فیلتر تیکت‌ها</span>
              <div class="fRow jStart aCenter fullWidth inputWraper" style="margin-top: 16px">
                <radio
                  v-for="(item, index) in ticketFilters" v-bind:key="index"
                  :simple="true"
                  :data="item"
                  style="padding-left: 24px"
                  :selected="item.id === ticketFilter"
                  @click.native="ticketFilter = item.id" />
              </div>
            </div>
            <div class="fCol jStart aStart formTop growFull">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round">sort</i>
                مرتب سازی</span>
              <div class="fRow jStart aCenter fullWidth inputWraper" style="margin-top: 16px">
                <radio
                  v-for="(item, index) in sorts" v-bind:key="index"
                  :simple="true"
                  :data="item"
                  style="padding-left: 24px"
                  :selected="item.id === sort"
                  @click.native="sort = item.id" />
              </div>
            </div>
          </div>
          <!-- tickets -->
          <div class="fullWidth fCol jCenter aCenter list">
            <ul class="tickets fullWidth fCol jCenter aCenter">
              <li class="ticket fRow jBetween aCenter fullWidth">
                <div class="index">#</div>
                <div class="avatar"></div>
                <div class="fCol jCenter aStart growFull">
                </div>
                <div class="priority fCol jCenter aCenter">
                  <label class="label">اولویت</label>
                </div>
                <div class="messagesCount fCol jCenter aCenter">
                  <label class="label">تعداد پیام</label>
                </div>
                <div class="actions fRow jCenter aCenter">
                  <label class="label">عملیات</label>
                </div>
              </li>
              <li class="ticket fRow jBetween aCenter fullWidth"
                v-for="(ticket, index) in tickets" v-bind:key="index">
                <div class="index">{{index + 1}}</div>
                <div class="avatar">
                  <div class="av"></div>
                </div>
                <div class="fCol jCenter aStart growFull">
                  <div class="senderName fullWidth">
                    {{ticket.sender.name}}
                  </div>
                  <div class="date fullWidth fCol jCenter aStart">
                    <span class="big">آخرین پیام: {{formatDate(ticket.lastDate)}}</span>
                    <span class="mini">از {{formatDate(ticket.startAt)}}</span>
                  </div>
                </div>
                <div class="priority fCol jCenter aCenter">
                  <span v-bind:style="{
                      backgroundColor: `${priority(ticket.priority).color}`
                    }">
                    {{priority(ticket.priority).label}}
                  </span>
                </div>
                <div class="messagesCount fCol jCenter aCenter">
                  <span>{{ticket.messageCount}} پیام</span>
                </div>
                <div class="actions fRow jCenter aCenter">
                  <btn
                    label='آرشیو'
                    :fab="true"
                    :mini="true"
                    :flat="true"
                    v-if="true"
                    ic='inbox'/>
                  <btn
                    label='مشاهده'
                    :fab="true"
                    :mini="true"
                    :flat="true"
                    v-if="true"
                    :badge="ticket.messageCount"
                    @click.native="showTicket(ticket.id)"
                    ic='drafts'/>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Messages -->
        <div class="fCol jStart aStart fullWidth"
          v-if="activeForm === 'ticket'">
          <!-- card header -->
          <div class='fRow fullWidth jStart aCenter' style="margin-bottom: 32px">
            <div class='growFull fCol jStart aStart'>
              <h3 class='growFull text-right'>نام فرستنده</h3>
              <p class='note'>کد پیام.
              </p>
            </div>
            <btn
              label='بازگشت'
              :fab="true"
              :mini="true"
              :flat="true"
              v-if="true"
              @click.native="goBack()"
              ic='keyboard_arrow_left'/>
          </div>
          <div class="fullWidth fCol jStart aCenter newMessage">
            <div class="fullWidth fCol jStart aStart inputHolder">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: ticketPart === -1}">category</i>
                پیام شما مربوط به کدام بخش است؟</span>
              <div class="fullWidth fRow jBetween aCenter wrap type">
                <radio
                  v-for="(item, index) in ticketParts" v-bind:key="index"
                  :data="item"
                  :simple="true"
                  class="w33"
                  :selected="item.id === ticketPart"
                  @click.native="ticketPart = item.id" />
              </div>
            </div>
            <div class="fullWidth fCol jStart aStart inputHolder">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: titleErr}">title</i>
                عنوان پیام را وارد کنید - {{title.length}}/24</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <input
                  class="transition-fast" placeholder="عنوان پیام"
                  type="text" v-model="title">
              </div>
            </div>
            <div class="fullWidth fCol jStart aStart inputHolder">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: messageErr}">message</i>
                  متن پیام را وارد کنید - {{message.length}}/540</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <textarea
                  class="transition-fast" placeholder="متن پیام"
                  type="text" v-model="message"></textarea>
              </div>
            </div>
            <get-photo
              w='100%'
              photoFor='ticket'
              @photoupload="ticketFile = $event"
              :initImg='ticketFile'
              uploadMsg='اسکرین شات یا تصویر مورد نظر را آپلود کنید'
              uploadLabel='آپلود تصویر'/>
            <div class="fRow fullWidth jStart aCenter">
              <div class="b fRow jStart aCenter big"
                v-bind:class="{ active: ticketFormReady }">
                <i class="material-icons-round">send</i>
                <label>ارسال تیکت</label>
              </div>
            </div>
          </div>
          <ul class="messages fullWidth fCol jStart aCenter">
            <li class="fCol jStart aStart you">
              <div class="head fRow jStart aCenter fullWidth">
                <div class="avatar"></div>
                <span>ادمین سیستم</span>
              </div>
              <div class="content fullWidth fCol jStart aStart">
                <p class="fullWidth">
                  متن پیام
                </p>
              </div>
            </li>
            <li class="fCol jStart aStart they">
              <div class="head fRow jStart aCenter fullWidth">
                <div class="avatar"></div>
                <span>فرستنده</span>
              </div>
              <div class="content fullWidth fCol jStart aStart">
                <p class="fullWidth">
                  متن پیام
                </p>
              </div>
            </li>
          </ul>
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <div class="modal">
      <div class="closer"></div>
      <div class="box"></div>
    </div>
  </div>
</template>

<script>
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/NewBtn.vue';
import Radio from '@/components/Radio.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import moment from 'moment-jalaali';
import GetPhoto from '@/components/GetPhotoExam.vue';
import '@/assets/new.scss';

export default {
  data() {
    return {
      ticketFilters: [
        {
          id: 0,
          title: 'همه‌ی پیام‌ها',
        },
        {
          id: 1,
          title: 'خوانده نشده',
        },
        {
          id: 2,
          title: 'خوانده شده',
        },
        {
          id: 3,
          title: 'آرشیو شده',
        },
      ],
      ticketFilter: 0,
      sorts: [
        {
          id: 0,
          title: 'جدید ترین',
        },
        {
          id: 1,
          title: 'قدیمی ترین',
        },
      ],
      tickets: [
        {
          id: 'asdasd',
          startAt: '2022-01-15T13:45',
          lastDate: '2022-03-10T19:00',
          sender: {
            name: 'مهدی کاظمی',
            id: 'asdawoerjwe',
            avatar: '',
          },
          priority: 1,
          messageCount: 4,
        },
        {
          id: 'asdasdd',
          startAt: '2022-01-15T19:25',
          lastDate: '2022-04-15T09:00',
          sender: {
            name: 'رضا سبحانی',
            id: 'asdawoe34rjwe',
            avatar: '',
          },
          priority: 2,
          messageCount: 22,
        },
        {
          id: 'assda234sd',
          startAt: '2022-02-17T09:25',
          lastDate: '2022-03-25T19:00',
          sender: {
            name: 'احمد رضوانی',
            id: 'asda234woerjwe',
            avatar: '',
          },
          priority: 1,
          messageCount: 2,
        },
        {
          id: 'asdfas234d',
          startAt: '2022-03-15T19:25',
          lastDate: '2022-05-05T09:00',
          sender: {
            name: 'الهام اکبری',
            id: 'asdawa234doerjwe',
            avatar: '',
          },
          priority: 3,
          messageCount: 3,
        },
      ],
      sort: 0,
      selectedTicketId: '',
      activeForm: 'list',
      ticketParts: [
        {
          id: 1,
          title: 'بخش آموزشی',
          desc: 'سؤالات مربوط به منابع آموزشی و ',
        },
        {
          id: 2,
          title: 'بخش مشاوره',
          desc: 'سؤالات مربوط به منابع آموزشی و ',
        },
        {
          id: 3,
          title: 'بخش فنی',
          desc: 'اپلیکیشن و وب سایت ',
        },
        {
          id: 4,
          title: 'گزارش خطا',
          desc: 'سؤالات مربوط به منابع آموزشی و ',
        },
        {
          id: 5,
          title: 'گزارش سواستفاده',
          desc: 'سؤالات مربوط به منابع آموزشی و ',
        },
        {
          id: 6,
          title: 'انتقاد',
          desc: 'سؤالات مربوط به منابع آموزشی و ',
        },
      ],
      ticketPart: -1,
      title: '',
      titleErr: true,
      message: '',
      messageErr: true,
      ticketFile: '',
    };
  },
  methods: {
    // format date
    formatDate(d) {
      let dd = '';
      if (d.includes('T')) {
        dd = moment(d, 'YYYY-MM-DDTHH:mm:ss')
          .locale('fa')
          .format('jDD jMMMM jYYYY، ساعت HH:mm');
      } else {
        dd = moment(d, 'YYYY-MM-DDTHH:mm:ss')
          .locale('fa')
          .format('jDD jMMMM jYYYY');
      }
      return dd;
    },
    priority(p) {
      let pr = '';
      let bg = '';
      switch (p) {
        case 1: {
          pr = 'معمولی';
          bg = 'var(--gray5)';
          break;
        }
        case 2: {
          pr = 'بالا';
          bg = 'var(--themeOrange)';
          break;
        }
        case 3: {
          pr = 'خیلی بالا';
          bg = 'var(--themeRed)';
          break;
        }
        default:
          break;
      }
      return {
        label: pr,
        color: bg,
      };
    },
    showTicket(id) {
      this.$router.push(`/tickets?ticket=${id}`);
      this.handleRoute();
    },
    goBack() {
      this.$router.push('/tickets');
      this.handleRoute();
    },
    handleRoute() {
      const queryObj = this.$router.currentRoute.query;
      const [ticket] = [queryObj.ticket];
      if (ticket === undefined
        || ticket === ''
        || ticket === null) {
        console.error('اوکی نیست');
        this.activeForm = 'list';
      } else {
        this.selectedTicketId = queryObj.ticket;
        this.activeForm = 'ticket';
      }
      console.warn(ticket);
    },
  },
  computed: {
    ticketFormReady() {
      return this.ticketPart !== -1
        && !this.titleErr
        && !this.messageErr;
    },
  },
  watch: {
    selectedTicketId() {
      this.handleRoute();
    },
    title() {
      this.title = this.title.substr(0, 24);
      this.titleErr = this.title.length < 3;
    },
    message() {
      this.message = this.message.substr(0, 540);
      this.messageErr = this.message.length < 3;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.commit('setLoadingOff');
      this.handleRoute();
    });
  },
  components: {
    RightMenu,
    ToolBar,
    Card,
    Btn,
    Radio,
    DashboardPage,
    GetPhoto,
  },
};
</script>

<style lang="scss" scoped>
.formTop {
  padding: 12px;
  border-radius: 24px;
  background-color: var(--normalText05);
  margin: 4px;
  span {
    font-size: 14px;
    i {
      font-size: 16px;
      margin-left: 8px;
      color: var(--normalText8);
    }
  }
}
.list {
  ul.tickets {
    padding: 0;
    margin: 0;
    li.ticket {
      padding: 16px;
      border-bottom: dashed 1px var(--normalText1);
      .index {
        font-size: 10px;
        width: 24px;
        text-align: right;
        color: var(--normalText8);
      }
      .avatar {
        $w: 64px;
        width: 88px;
        .av {
          border-radius: 50%;
          width: $w;
          min-width: $w;
          height: $w;
          background-color: var(--normalText15);
        }
      }
      .senderName {
        font-size: 15px;
        margin-bottom: 8px;
        color: var(--normalText);
        text-align: right;
      }
      .date {
        font-size: 12px;
        color: var(--normalText9);
        text-align: right;
        span.mini {
          font-size: 10px;
          line-height: 1;
        }
        span.big {
          font-size: 12px;
          line-height: 1;
          margin-bottom: 4px;
        }
      }
      .priority {
        width: 112px;
        span {
          padding: 4px 8px;
          border-radius: 16px;
          background-color: var(--invertText8);
          color: var(--themeWhite);
          font-size: 12px;
        }
      }
      .messagesCount {
        width: 96px;
        span {
          padding: 4px 8px;
          border-radius: 16px;
          color: var(--normalText);
          font-size: 12px;
        }
      }
      .actions {
        width: 164px;
        border-right: solid 1px var(--normalText05);
      }
      label.label {
        font-size: 12px;
        font-weight: 300;
        color: var(--normalText85);
      }
    }
  }
}
.type {
  margin-bottom: 16px;
  .radio {
    margin-top: 16px;
  }
}
.newMessage {
  border-radius: 16px;
  padding: 12px;
  background-color: var(--normalText05);
}
ul.messages {
  padding: 0;
  margin: 16px 0 0 0;
  li {
    background-color: var(--normalText05);
    margin-bottom: 8px;
    width: calc(100% - 64px);
    overflow: hidden;
    border-radius: 16px;
    .head {
      padding: 8px;
      background-color: var(--normalText05);
      .avatar {
        width: 32px;
        height: 32px;
        min-width: 32px;
        border-radius: 50%;
        background-color: var(--normalText2);
        margin-left: 8px;
      }
      span {
        font-size: 14px;
        font-weight: bold;
        color: var(--normalText);
        line-height: 1;
      }
    }
    .content {
      padding: 0 8px;
      p {
        line-height: 1.3;
        font-size: 14px;
        color: var(--normalText);
        text-align: justify;
      }
    }
  }
  li.you {
    margin-left: 64px;
  }
  li.they {
    margin-right: 64px;
  }
}
</style>
